<script>
import WishlistButton from '@phoenix/mixins/components/wishlist/WishlistButton';
import { PhxIcon } from '@phx-styleguides/als';

export default {
  components: { PhxIcon },

  mixins: [WishlistButton],

  props: {
    hasLabel: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    label() {
      return this.isInWishlist(this.reference) ? this.$t('Wishlist.removeProduct') : this.$t('Wishlist.addToWishlist');
    },

    classes() {
      return ['btn', 'btn--icon', { 'btn--link btn--sm': this.hasLabel, 'btn--icon-only': !this.hasLabel }];
    },
  },
};
</script>

<template>
  <button
    :class="classes"
    :aria-label="ariaLabel"
    :data-cy="dataCy"
    :data-tracking="trackingDatalayer"
    @click.prevent="toggleProduct({ reference, showBanner })"
  >
    <span class="btn__icon">
      <phx-icon :key="icon" :icon="icon" />
    </span>
    <span v-if="hasLabel" class="btn__text">{{ label }}</span>
  </button>
</template>
